export default {
      id: "visibility-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#visibility-usage",
      toString: function () {
        return this.url;
      }
    }